import { useState } from "react";

const jobTypes = [
  { value: "", label: "Tất cả loại" },
  { value: "full-time", label: "Toàn thời gian" },
  { value: "part-time", label: "Bán thời gian" },
  { value: "contract", label: "Hợp đồng" },
];

const sortOptions = [
  { value: "newest", label: "Mới nhất" },
  { value: "oldest", label: "Cũ nhất" },
  { value: "salary-high", label: "Lương cao → thấp" },
  { value: "salary-low", label: "Lương thấp → cao" },
];

interface AdvancedFilterPanelProps {
  jobType: string;
  sortBy: string;
  onJobTypeChange: (value: string) => void;
  onSortChange: (value: string) => void;
}

export default function AdvancedFilterPanel({
  jobType,
  sortBy,
  onJobTypeChange,
  onSortChange,
}: AdvancedFilterPanelProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="w-full">
      {/* Toggle button */}
      <div className="flex items-center justify-between mb-4">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="inline-flex items-center gap-2 px-4 py-2 bg-background-100 border border-background-200/70 rounded-full text-sm font-medium text-foreground-700 hover:bg-background-200 hover:text-foreground-900 transition-all duration-200 cursor-pointer whitespace-nowrap"
        >
          <i className={`ri-equalizer-line text-base ${(jobType || sortBy !== "newest") ? "text-primary-500" : ""}`}></i>
          <span>Bộ lọc nâng cao</span>
          {(jobType || sortBy !== "newest") && (
            <span className="flex items-center justify-center w-5 h-5 rounded-full bg-primary-500 text-background-50 text-xs font-bold">
              {[jobType, sortBy !== "newest" ? sortBy : ""].filter(Boolean).length}
            </span>
          )}
          <i className={`ri-arrow-down-s-line text-base transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}></i>
        </button>
      </div>

      {/* Expandable panel */}
      <div
        className={`transition-all duration-400 ease-in-out overflow-hidden ${
          isOpen ? "max-h-[500px] opacity-100 mb-6" : "max-h-0 opacity-0"
        }`}
      >
        <div className="bg-background-100/70 border border-background-200/70 rounded-2xl p-5 md:p-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {/* Loại công việc */}
            <div>
              <label className="block text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-3">
                <i className="ri-briefcase-4-line mr-1.5"></i>
                Loại công việc
              </label>
              <div className="flex flex-wrap gap-2">
                {jobTypes.map((jt) => (
                  <button
                    key={jt.value}
                    onClick={() => onJobTypeChange(jt.value)}
                    className={`px-3.5 py-2 text-sm font-medium rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap ${
                      jobType === jt.value
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-50 text-foreground-600 hover:bg-background-200 border border-background-200/70"
                    }`}
                  >
                    {jt.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Sắp xếp */}
            <div>
              <label className="block text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-3">
                <i className="ri-sort-desc mr-1.5"></i>
                Sắp xếp theo
              </label>
              <div className="flex flex-wrap gap-2">
                {sortOptions.map((so) => (
                  <button
                    key={so.value}
                    onClick={() => onSortChange(so.value)}
                    className={`px-3.5 py-2 text-sm font-medium rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap ${
                      sortBy === so.value
                        ? "bg-secondary-500 text-background-50"
                        : "bg-background-50 text-foreground-600 hover:bg-background-200 border border-background-200/70"
                    }`}
                  >
                    {so.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Reset */}
            <div className="flex items-end">
              <button
                onClick={() => {
                  onJobTypeChange("");
                  onSortChange("newest");
                }}
                className="inline-flex items-center gap-1.5 px-4 py-2 text-sm font-medium text-foreground-500 hover:text-foreground-800 hover:bg-background-200 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-refresh-line text-base"></i>
                Đặt lại bộ lọc
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}